import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ACCOUNTDETAIL_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.AccountDetail.Name')
    .required()
    .build(),
];

export const ACCOUNTDETAIL_CONFIG = {
  entityName: 'AccountDetail',
  localizationKey: 'Controlling::Entity.AccountDetail',
  fields: ACCOUNTDETAIL_FIELDS,
  permission: 'ControllingSap.AccountDetails',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
